import Flickity from 'flickity'

export default {
  name: 'carousel',

  componentDidMount () {
    this.flickity = new Flickity(this.el, {
      pageDots: true,
      wrapAround: true,
    })
  },
}
